export default __webpack_public_path__ + "static/media/miguel-lopes-10.69f585aa.jpg";